module.exports = __webpack_public_path__ + "static/media/image-grid-1.3f24fe39.svg";